import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-servisbot-prompt-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './servisbot-prompt-modal.component.html',
  styleUrl: './servisbot-prompt-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServisBotPromptModalComponent {
  isOpen = input<boolean>(false);

  isBusinessHours = input<boolean>(false);

  continueWithMessage = output<void>();

  openChat = output<void>();

  closed = output<void>();

  protected onContinueWithMessage(): void {
    this.continueWithMessage.emit();
  }

  protected onOpenChat(): void {
    this.openChat.emit();
  }

  protected onClose(): void {
    this.closed.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closed.emit();
    }
  }
}
